/**
 * Methode zum Überwachen von Attributen
 */
(function ($) {
    $.fn.formCalculator = function () {
        var getAge = function(dateString) {
            if (!dateString) {
                return null;
            }

            dateString = dateString.split('.');
            if (dateString.length === 3 && dateString[2].length < 4) {
                dateString[2] = '19' + dateString[2];
            }
            dateString = dateString[2] + '-' + dateString[1] + '-' + dateString[0];

            var today = new Date();
            var birthDate = new Date(dateString);
            var age = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            return age;
        }

        return this.each(function () {
            var $form = $(this);

            /**
             * Show / hide „fehlende Zähne mitversichern“
             */
            var $missingTeeth = $form.find('select[name="missingTeeth"]');
            var toggleInsureMissingTeethQuestion = function (event) {
                var duration = typeof event === 'object' ? 400 : 0;

                if ($(this).val() > 0) {
                    $form.find('.fehlende-zaehne-mitversichern-group').slideDown(duration);
                } else {
                    $form.find('.fehlende-zaehne-mitversichern-group').slideUp(duration);
                }
            };
            $missingTeeth.on('change', toggleInsureMissingTeethQuestion);
            $missingTeeth.each(toggleInsureMissingTeethQuestion);

            /**
             * Show / hide „Wie viele davon sind älter als 10 Jahre?“
             */
            var $zaehneMitZahnersatz = $form.find('select[name="teethWithDentures"]');
            var toggleZaehneMitZahnersatzAelterQuestion = function (event) {
                var duration = typeof event === 'object' ? 400 : 0;
                var numZaehneMitZahnersatz = parseInt($(this).val());

                if (numZaehneMitZahnersatz > 0) {
                    $form.find('.zaehne-mit-zahnersatz-aelter-group').slideDown(duration);

                    var $select = $form.find('select[name="teethWithDenturesOlder"]');
                    $select.find('option').each(function () {
                        var value = parseInt(this.value);

                        if (value > numZaehneMitZahnersatz) {
                            $(this).hide();
                            $(this).attr('disabled', 'disabled');
                        } else {
                            $(this).show();
                            $(this).removeAttr('disabled');
                        }
                    });
                } else {
                    $form.find('.zaehne-mit-zahnersatz-aelter-group').slideUp(duration);
                }
            };
            $zaehneMitZahnersatz.on('change', toggleZaehneMitZahnersatzAelterQuestion);
            $zaehneMitZahnersatz.each(toggleZaehneMitZahnersatzAelterQuestion);

            /**
             * Show / hide „Parodontose aktuell Frage“
             */
            var $periodontosis = $form.find('input[name="periodontosis"]');
            var toggleParodontoseAktuellQuestion = function (event) {
                var isChecked = $form.find('input[name="periodontosis"]').filter(':checked').val() > 0;
                var duration = typeof event === 'object' ? 400 : 0;

                if (isChecked) {
                    $form.find('.parodontose-aktuell-group').slideDown(duration);
                } else {
                    $form.find('.parodontose-aktuell-group').slideUp(duration);
                }
            };
            $periodontosis.on('change', toggleParodontoseAktuellQuestion);
            $periodontosis.each(toggleParodontoseAktuellQuestion);

            /**
             * Behandlungsfragen
             */
            var toggleBehandlungsfragen = function (event) {
                var duration = typeof event === 'object' ? 400 : 0;

                var $groupKontrolluntersuchung = $form.find('.laufende-behandlung-nur-kontrolle-group');
                var $groupOrthodontics = $form.find('.orthodontics-group');
                var $groupErsetzen = $form.find('.zahnersatz-sofort-erstatten-group');
                var $groupKunststofffuellungen = $form.find('.laufende-behandlung-nur-kunststofffuellungen-group');

                var age = getAge($form.find('input[name="birthday"]').val());
                var treatment = $form.find('input[name="treatment"]:checked').val() > 0;
                var missingTeeth = $form.find('select[name="missingTeeth"]').val();
                var insureMissingTeeth = $form.find('input[name="insureMissingTeeth"]:checked').val();

                if (treatment) {
                    $groupKontrolluntersuchung.showGroup(duration);
                } else {
                    $groupKontrolluntersuchung.hideGroup(duration);
                    $groupOrthodontics.hideGroup(duration);
                    $groupErsetzen.hideGroup(duration);
                    $groupKunststofffuellungen.hideGroup(duration);
                    return;
                }

                /**
                 * Keine weiteren Fragen einblenden,
                 * wenn sich die Behandlungen ausschließlich um die jährliche
                 * Kontrolluntersuchung oder um eine Zahnreinigung handelt
                 *
                 * Oder auch wenn diese Frage nicht beantwortet wurde
                 */
                if ($groupKontrolluntersuchung.find('input[value="1"]').is(':checked')
                    || !$groupKontrolluntersuchung.find('input:checked').length
                ) {
                    $groupOrthodontics.hideGroup(duration);
                    $groupErsetzen.hideGroup(duration);
                    $groupKunststofffuellungen.hideGroup(duration);
                    return;
                }

                /**
                 * Frage nach kieferorthopädischen Behandlungen nur beim Alter <= 21
                 */
                if (age !== null && age >= 0 && age <= 21) {
                    $groupOrthodontics.showGroup(duration);

                    if (
                        $groupOrthodontics.find('input[value="1"]').is(':checked')
                        || !$groupOrthodontics.find('input:checked').length
                    ) {
                        $groupErsetzen.hideGroup(duration);
                        $groupKunststofffuellungen.hideGroup(duration);
                        return;
                    }
                } else {
                    $groupOrthodontics.hideGroup(duration);
                }

                /**
                 * Zusatzfrage ein/ausblenden, ob sich die laufende Behandlung nur
                 * um das Ersetzen fehlender Zähne handelt
                 */
                if (insureMissingTeeth
                    && missingTeeth >= 1
                    && missingTeeth <= 3
                ) {
                    $groupErsetzen.showGroup(duration);
                } else {
                    $groupErsetzen.hideGroup(duration);
                }

                if (!$groupErsetzen.groupIsHidden()
                    && (
                        $groupErsetzen.find('input[value="1"]').is(':checked')
                        || !$groupErsetzen.find('input:checked').length
                    )
                ) {
                    $groupKunststofffuellungen.hideGroup(duration);
                    return;
                }

                $groupKunststofffuellungen.showGroup(duration);
            };
            $form.on('change', toggleBehandlungsfragen);
            $form.each(toggleBehandlungsfragen);
        });
    };
})(jQuery);
